import { colors } from '../../../core/theme/tokens';

export type GlassTint = 'neutral' | 'accent' | 'tabBar';

export const glassTokens = {
  neutral: {
    fill: colors.glass,
    border: colors.glassBorder,
    sheen: 'rgba(255, 255, 255, 0.05)',
    hairline: 'rgba(255, 255, 255, 0.08)',
  },
  accent: {
    fill: 'rgba(61, 214, 164, 0.14)',
    border: 'rgba(61, 214, 164, 0.38)',
    sheen: 'rgba(61, 214, 164, 0.08)',
    hairline: 'rgba(61, 214, 164, 0.25)',
  },
  tabBar: {
    fill: colors.tabBarGlass,
    border: colors.tabBarGlassBorder,
    sheen: 'rgba(255, 255, 255, 0.06)',
    hairline: colors.tabBarHairline,
  },
} as const;

export type GlassButtonVariant = 'primary' | 'secondary' | 'ghost';

export const buttonVariantTint: Record<GlassButtonVariant, GlassTint | 'none'> = {
  primary: 'accent',
  secondary: 'neutral',
  ghost: 'none',
};

export const buttonTextColor: Record<GlassButtonVariant, string> = {
  primary: colors.accent,
  secondary: colors.text,
  ghost: colors.textMuted,
};
